import { Component, Input, signal, WritableSignal } from '@angular/core';
import { LnEmptySearchCardComponent } from '@components/cards/ln-empty-search-card/ln-empty-search-card.component';
import { SellerInterface } from '@interfaces/artisan/seller_interface';
import { SellerCardComponent } from '@components/cards/seller-card/seller-card.component';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'ln-artisan-designer-search-result',
  imports: [LnEmptySearchCardComponent, SellerCardComponent, TranslocoPipe],
  templateUrl: './artisan-designer-search-result.component.html',
  styleUrl: './artisan-designer-search-result.component.css',
})
export class ArtisanDesignerSearchResultComponent {
  @Input({ required: true }) sellers: WritableSignal<SellerInterface[] | null> = signal<SellerInterface[] | null>(null);
}
